module.exports = __webpack_public_path__ + "img/logo-white.b5662871.png";